import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PAYROLL_WORK_ON_PROJECTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.CREATE_PAYROLL_WORK_ON_PROJECT:
      return { ...state, [action.payload.Id]: action.payload };
    // return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_PAYROLL_WORK_ON_PROJECT:
      return { ...state, [action.payload.Id]: action.payload };
    // return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.DELETE_PAYROLL_WORK_ON_PROJECT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
